import React, { FC, forwardRef } from 'react';
import { Text, TextStyle } from 'react-native';
import { useTheme } from './theme';

interface H1Props {
  as?: 'h1' | 'h2' | 'h3' | 'h4';
  style?: TextStyle;
}

const H1Component: FC<H1Props> = (props, ref) => {
  const { children, as = 'h1', style } = props;
  const ariaLevel = as.charAt(1);
  const { fonts } = useTheme();

  return (
    <Text
      accessible={true}
      accessibilityRole="header"
      aria-level={ariaLevel}
      ref={ref}
      style={{ ...fonts.serif.reg, ...style }}
    >
      {children}
    </Text>
  );
};

const H1: FC<H1Props> = forwardRef(H1Component);

export { H1 };
